<template>
  <div class="container admin-roles-page">
    <div class="param-title-wrap">
      <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
      </b-button>
      <h2 class="param-title">{{ labels.title }}</h2>
    </div>

    <div class="admin-table-block mt-4" v-if="listaReportes?.length">
      <CorporateDataTable
        :items="listaReportes"
        :fields="allFields"
        :filter-defs="tableFilterDefs"
        :labels="tableLabels"
        :default-per-page="10"
        :page-options="[10, 20, 50, 100]"
        :narrow="false"
        :table-min-height="500"
        :table-max-height="500"
      >
        <template #toolbar-actions>
          <b-button size="sm" class="table-toolbar-add-btn" @click="creaReporte">
            {{ labels.create }}
          </b-button>
        </template>
        
        <template #cell(principal)="data">
          <span>{{ data.item.principal ? labels.yes : labels.not }}</span>
        </template>

        <template #cell(accionEdit)="data">
          <b-button
            style="background-color: #FF924C; width: 30px; height: 30px;"
            class="md-fab md-primary table-action-btn"
            @click="editReporte(data.item)"
          >
            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
          </b-button>
        </template>
        
        <template #cell(accionDelete)="data">
          <b-button
            style="background-color: #cd2838; width: 30px; height: 30px;"
            class="md-fab md-primary table-action-btn"
            @click="deleteReporte(data.item.id)"
          >
            <i><font-awesome-icon :icon="['fas', 'trash-alt']" size="xs"/></i>
          </b-button>
        </template>
      </CorporateDataTable>
    </div>
    
    <div class="admin-table-block mt-4" v-else>
      <h5>{{ labels.notFoundMessage }}</h5>
      <div class="mt-3">
        <b-button size="sm" class="table-toolbar-add-btn" @click="creaReporte">
          {{ labels.create }}
        </b-button>
      </div>
    </div>

    <!-- Modales -->
    <CreaReporte 
      :modCreaReporte="modCreaReporte" 
      @refrescaTbl="reloadTbl" 
      @closeModal="cierraModal"
    />
    <EditaReporte 
      :modEditaReporte="modEditaReporte" 
      :ItemReport="infoReporte" 
      @refrescaTbl="reloadTbl" 
      @closeModal="cierraModal"
    />
    <InacticaItem 
      :InactivaItem="deletFila" 
      @confirmDelete="confirmDel" 
      @cierraModal="closeMod"
    />
  </div>
</template>

<script>
import TipoReporte from '../../../services/TipoReporte'
import CorporateDataTable from '../../utils/CorporateDataTable.vue'
import CreaReporte from './CreaReporte.vue'
import EditaReporte from './EditaReporte.vue'
import InacticaItem from '../../utils/InacticaItem.vue'

export default {
  name: 'TipoReporte',
  components: {
    CorporateDataTable,
    CreaReporte,
    EditaReporte,
    InacticaItem
  },
  data: () => ({
    isLoading: false,
    listaReportes: [],
    modCreaReporte: false,
    modEditaReporte: false,
    infoReporte: {},
    idReportDel: null,
    deletFila: false
  }),
  computed: {
    labels() {
      const isEs = this.$store.state._language == "es-ES"
      return {
        title: isEs ? 'Tipos de Reporte' : 'Report Types',
        create: isEs ? 'Crear' : 'Create',
        codigo: isEs ? 'Código' : 'Code',
        nombre: isEs ? 'Nombre' : 'Name',
        principal: isEs ? 'Principal' : 'Principal',
        libro_notas: isEs ? 'Libro Notas' : 'Notes',
        yes: isEs ? 'SI' : 'YES',
        not: isEs ? 'NO' : 'NO',
        edit: isEs ? 'Editar' : 'Edit',
        delete: isEs ? 'Eliminar' : 'Delete',
        notFoundMessage: isEs ? 'No hay registros' : 'No records found'
      }
    },
    allFields() {
      const fields = [
        { key: 'codigo', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'nombre', label: this.labels.nombre, sortable: true, thClass: 'text-center', tdClass: 'text-left' },
        { key: 'principal', label: this.labels.principal, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center', sortable: false },
        { key: 'accionDelete', label: this.labels.delete, thClass: 'text-center', tdClass: 'text-center', sortable: false }
      ]
      
      // Solo agregar columna libro_notas si hay algún dato
      const hasLibroNotas = this.listaReportes.some(item => item.libro_notas && item.libro_notas.trim() !== '')
      if (hasLibroNotas) {
        fields.splice(3, 0, { key: 'libro_notas', label: this.labels.libro_notas, sortable: true, thClass: 'text-center', tdClass: 'text-left' })
      }
      
      return fields
    },
    tableFilterDefs() {
      const isEs = this.$store.state._language == "es-ES"
      return [
        { key: 'codigo', type: 'text', placeholder: isEs ? 'Filtrar código...' : 'Filter code...' },
        { key: 'nombre', type: 'text', placeholder: isEs ? 'Filtrar nombre...' : 'Filter name...' }
      ]
    },
    tableLabels() {
      const isEs = this.$store.state._language == "es-ES"
      return {
        noRow: this.labels.notFoundMessage,
        noMatches: isEs ? "No se encontraron resultados" : "No results found",
        searchPlaceholder: isEs ? "Buscar en la tabla..." : "Search in table...",
        rowsPerPage: isEs ? "Filas por página:" : "Rows per page:",
        noSort: isEs ? "Sin orden" : "No sorting",
        sortAsc: isEs ? "A-Z / Menor a mayor" : "A-Z / Low to high",
        sortDesc: isEs ? "Z-A / Mayor a menor" : "Z-A / High to low",
        columns: isEs ? "Columnas" : "Columns",
        showAllColumns: isEs ? "Mostrar todas" : "Show all",
        filters: isEs ? "Filtros" : "Filters",
        clearFilters: isEs ? "Limpiar filtros" : "Clear filters"
      }
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    
    cierraModal(valor) {
      this.modCreaReporte = valor
      this.modEditaReporte = valor
    },
    
    closeMod(valor) {
      this.deletFila = valor
    },
    
    creaReporte() {
      this.modCreaReporte = true
    },
    
    editReporte(item) {
      this.infoReporte = item
      this.modEditaReporte = true
    },
    
    deleteReporte(id) {
      this.idReportDel = id
      this.deletFila = true
    },
    
    confirmDel() {
      this.isLoading = true
      TipoReporte.deleteReporte(this.idReportDel)
        .then((res) => {
          this.$toast?.success(res.data.message || 'Reporte eliminado exitosamente')
          this.reloadTbl()
          this.deletFila = false
        })
        .catch((err) => {
          console.error(err)
          this.$toast?.error(err.response?.data?.message || 'Error al eliminar el reporte')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    
    reloadTbl() {
      this.isLoading = true
      TipoReporte.getAllTipoReporte()
        .then((res) => {
          this.listaReportes = res.data.typeReport || []
          this.modCreaReporte = false
          this.modEditaReporte = false
        })
        .catch((err) => {
          console.error(err)
          this.$toast?.error('Error al cargar los datos')
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted() {
    this.reloadTbl()
  }
}
</script>

<style src="../../main.css"></style>

<style scoped>
/* Solo estilos mínimos necesarios, sin redefinir la tarjeta */
.admin-roles-page {
  padding: 20px;
}

.param-title-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.page-back-btn {
  padding: 0;
  font-size: 1.5rem;
  line-height: 1;
  color: #1f4f83;
}

.page-back-btn:hover {
  color: #163d67;
}

.param-title {
  font-size: 2rem !important;
  font-weight: 500;
  margin: 0;
}

.table-toolbar-add-btn {
  height: 31px;
  min-height: 31px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 7px;
  font-size: 13px;
  background-color: #28a745;
  color: white;
  border: 1px solid #28a745;
}

.table-toolbar-add-btn:hover:not(:disabled) {
  background-color: #218838;
  border-color: #1e7e34;
}

.table-toolbar-add-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.table-action-btn {
  border: none;
  border-radius: 4px;
  transition: all 0.2s;
}

.table-action-btn:hover {
  opacity: 0.85;
  transform: scale(1.05);
}

@media (max-width: 576px) {
  .param-title {
    font-size: 1.5rem !important;
  }
}
</style>